export enum RequesterErrorType {
  Request = 'request',
  Response = 'response',
}
